var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXirifyConv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.174,
    height: 16.979,
    viewBox: "0 0 15.174 16.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42064",
    "data-name": "Group 42064",
    transform: "translate(-364.5 -234.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    transform: "translate(364.5 234.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069",
    transform: "translate(6.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M413.239,248.162a1.775,1.775,0,0,1-1.312.573,1.742,1.742,0,0,1-1.272-.533l-5.486-5.469a1.822,1.822,0,0,1-.533-1.29,1.753,1.753,0,0,1,.533-1.272l5.469-5.365a1.8,1.8,0,1,1,2.528,2.562l-2.914,2.461a2.168,2.168,0,0,0-.007,3.306l2.932,2.5A1.82,1.82,0,0,1,413.239,248.162Z",
    transform: "translate(-404.636 -234.285)",
    fill: "#bebebe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2070",
    "data-name": "Group 2070",
    transform: "translate(0 5.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M364.908,278.506l2.2-1.874a1.626,1.626,0,0,0-.005-2.479l-2.186-1.846a1.35,1.35,0,0,1,1.9-1.922l4.1,4.024a1.315,1.315,0,0,1,.4.954,1.367,1.367,0,0,1-.4.967l-4.114,4.1a1.307,1.307,0,0,1-.954.4,1.332,1.332,0,0,1-.984-.43A1.365,1.365,0,0,1,364.908,278.506Z",
    transform: "translate(-364.5 -269.995)",
    fill: "#bebebe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M402.042,332.976a1.084,1.084,0,1,1-1.084-1.084A1.084,1.084,0,0,1,402.042,332.976Z",
    transform: "translate(-394.507 -317.081)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M425.85,332.976a1.084,1.084,0,1,1-1.084-1.084A1.084,1.084,0,0,1,425.85,332.976Z",
    transform: "translate(-414.702 -317.081)",
    fill: "#bebebe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXirifyConv);
export default __webpack_public_path__ + "static/media/XirifyConv.d3f7da2159af1efc8e31891c4ff029ca.svg";
export { ForwardRef as ReactComponent };